import { render, staticRenderFns } from "./SettingsMain.vue?vue&type=template&id=da4431c0"
import script from "./SettingsMain.vue?vue&type=script&lang=js"
export * from "./SettingsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports